import React, { useEffect, useState,useRef } from "react";
import {
  Grid,
  Divider,
  StepConnector,
  styled,
  stepConnectorClasses,Avatar
} from "@mui/material";
import Box from "@mui/material/Box";
import { toast } from "react-toastify";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { BiSolidPhone } from "react-icons/bi";
import { CiCircleQuestion } from "react-icons/ci";
import {
  DarkGreenColorButton,
  GreenColorButton,
  PrimeGrayBorderColorButton,
  // RedColorBorderButton
} from "../../Components/MaterialButtonStyle/StyleButton";
import { OnlyDateConverter } from "../../Components/Helpers/DateTimeConverter";
import { FormatAmount } from "../../Components/Formatters/AmountFormat";
import { BsFillPersonFill } from "react-icons/bs";
import { FiUpload } from "react-icons/fi";

import CustomCheckBox from "../../Components/CheckBox/CustomCheckBox";
import CustomInput from "../../Components/CustomInputs/CustomInputs";
import CustomDropDown from "../../Components/DropDown/CustomDropDown";
import {
  GenderInfo,
  NigeriaStatesInfo,
  TitleInfo,
  MaritalStatusInfo
} from "../../Components/Templates/DataFile/Data";
import EducationalQualification from "../../Components/Templates/EducationalQualification";
import CandidateOtherDetails from "./CandidateOtherDetails";
import PSCLogo from "../../Assets/Logo/PSCLogo.jpg";
import ApplicationDetails from "../Applications/ApplicationDetails";
import DatePicker from "../../Components/DateRangeSelector/DatePicker";
import CustomModal from "../../Components/Modal/CustomModal";
// import AutoComplete from "../../Components/GoogleAutoComplete/AutoComplete";
import { formatDateToISO,formatDate } from "../../Components/Helpers/DateTimeConverter";
import {
  PostMethod,
  GetPublicURL,S3Upload
} from "../../Helper/api";
import LoaderModal from "../../Components/Modal/Loader";
import { useNavigate,useParams } from "react-router-dom";
import { Mandatory } from "../../Utils/index"
// import { RiDeleteBin6Line } from "react-icons/ri";

const ApplyJob = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const fileInputRef = useRef(null);
  const [stepper, setStepper] = useState(0);
  const [jobApplied, setJobApplied] = useState(false);
  const [ProfileIMAGES, setProfileIMAGES] = useState("");
  const [ProfileIMAGES1, setProfileIMAGES1] = useState("");
  const [Gender, setGender] = useState("");
  const [Affirmationcheck,setAffirmationcheck]=useState(false)
  const [basicDetails, setbasicDetails] = useState([]);
  const [KinDetails, setKinDetails] = useState([]);
  const [Workflow, setWorkflow] = useState([]);
  const [EducationQualification, setEducationQualification] = useState([]);
  const [informations, setinformations] = useState([]);
  const [furtherInformation, setFurtherInformation] = useState([]);
  const [Referees, setReferees] = useState([]);
  const [affirmation, setaffirmation] = useState();
  const [CandidateDetail, setCandidateDetail] = useState([]);
  const [EducationQualificationsInfo, setEducationQualificationsInfo] = useState([]);
  const [EducationLevel, setEducationLevel] = useState([]);
  const [Permanentaddeess,setPermanentaddeess]=useState()

  const [signature, setSignature] = useState("");
  const [placeName, setPlaceName] = useState("");
  const [submittedDate, setSubmittedDate] = useState("2025-01-28");
  const [conformModal, setConformModal] = useState(false);
  const [detailModal, setDetailModal] = useState("");
  const [jobDetails, setJobDetails] = useState(false);
  const [CandidateDetails, setCandidateDetails] = useState({});
  const [ShowLoader, setShowLoader] = useState(false);
  const [Job_application_id, setJob_application_id] = useState();

  const [PhysicalList, setPhysicalList] = useState([]);
  const [CBTList, setCBTList] = useState([]);
  const [medical_locations, setmedical_locations] = useState([]);
  const [physical_locations, setphysical_locations] = useState([]);
  const [computer_locations, setcomputer_locations] = useState([]);
  const [NigeriaReligions, setNigeriaReligions] = useState([]);
  const [RelationshipData, setRelationshipData] = useState([]);
  const [Baseaddeess, setBaseaddeess] = useState(); 
  const [Residentialaddeess, setResidentialaddeess] = useState();

  const [referenceDetails, setReferenceDetails] = useState({
    fullName: "",
    Phone: "",
    Details: "",
    Address: "",
  });
  const [physicalTest, setPhysicalTest] = useState([]);
  const [otherDetails, setOtherDetails] = useState({
    location1: null,
    location2: null,
    location3: null,
    cityList: [],
    cityMedicialList: [],
    cityCbtList: [],
    cbtLocation1: null,
    cbtLocation2: null,
    cbtLocation3: null,
    selectedState: "",
    selectedCbtState: "",
    selectedMedicalState: "",
    medicalLocation1: null,
    medicalLocation2: null,
    medicalLocation3: null,
  });
  const steps = [
    "Applicant Details",
    "Education Details",
    "Other Details",
    "Preview & Confirm",
  ];
  const ValidationEmails = (mail) => {
    /* eslint-disable */
    const regExp =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regExp.test(mail);
    /* eslint-enable */
  };
  const CustomConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 15,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: "#0FBE7C",
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: "#0FBE7C",
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 3,
      border: 0,
      backgroundColor: "rgba(224, 224, 224, .6)",
      borderRadius: 1,
      ...theme.applyStyles("dark", {
        backgroundColor: "rgba(224, 224, 224, .6)",
      }),
    },
  }));
  const ApplicationComplete = async () => { 
    try {
      basicDetails?.map((item) => {
        if(item.name!="Repeat Email" && item.name!="Other Phone Number" && item.name!="Hobbies" && item.name!="Other Name"){
          if (item.input == "dropdown") {
            if (!item.value || item.value?.trim().length == 0) {
              throw new Error(`Please Select ${item.name}`);
            }
          } else if (item.input == "text") {
            if (item.name == "Email") {
              if (!ValidationEmails(item.value)) {
                toast.error("Please Enter Valid Email Address");
                return;
              }
            }
            if(item.name == "Other Languages Spoken"){
              console.log(item.name)
            }else{
              if (!item.value || item.value?.trim().length == 0) {
                throw new Error(`Please Enter Valid ${item.name} `);
              }
            }
          } else if (item.input == "phone") {
            if (!item.value || item.value?.trim().length == 0) {
              throw new Error(`Please Enter Valid ${item.name} `);
            }
          }
        }
        
      });
    } catch (Error) {
      toast.error(Error.message);
      return;
    }
    try {
      KinDetails?.map((item) => {
        if (item.input == "dropdown") {
          if (!item.value || item.value?.trim().length == 0) {
            throw new Error(`Please Select Next of Kin Detail ${item.name}`);
          }
        } else if (item.input == "text") {
          if (item.name == "Email") {
            if (!ValidationEmails(item.value)) {
              throw new Error(`Please Enter Valid Email Address ${item.name}`);
            }
          }
          if (!item.value || item.value?.trim().length == 0) {
            throw new Error(
              `Please Enter Valid Next of Kin Detail  ${item.name} `
            );
          }
        } else if (item.input == "phone") {
          if (!item.value || item.value?.trim().length == 0) {
            throw new Error(
              `Please Enter Valid Next of Kin Detail ${item.name} `
            );
          }
          if (item.value?.trim().length != 10) {
            throw new Error(
              `Please Enter Valid Next of Kin Detail ${item.name} `
            );
          }
        }
      });
    } catch (Error) {
      toast.error(Error.message);
      return;
    }
    if (Job_application_id) {
      setStepper(1);
    } else {
      try {
        const userid = localStorage.getItem("@userid");
        if (!userid) {
          toast.warn("User authentication Failed ");
          return;
        }
        let url = "application/create";
        let method = "POST";
        let params = {
          candidate_id: userid,
          job_id: jobDetails.job_id,
          applicant_image: CandidateDetails?.candidate_image,
          ip_address: "192.168.0.1",
          signature: signature.localImage,
          application_temp_id: jobDetails.application_temp_id,
          workflow: Workflow,
          applicant_temp_details: basicDetails,
          kin_details: KinDetails,
        };
        setShowLoader(true);
        const response = await PostMethod({ url, method, params });

        if (response.status) {
          setJob_application_id(response.job_application_id);
          setStepper(1);
          setShowLoader(false);
        } else {
          if(response.message){
            toast.error(response.message)
          }else{
            toast.error("Something went wrong, please try again")
          }
          setShowLoader(false);
        }
      } catch (Error) {
        toast.error("Something went wrong, please try again")
        console.log("Error", Error);
      }
    }
  };
  const EducationComplete = async () => {
    if (Job_application_id) {
      try {
        EducationQualification.map((row,i) => {
          if(!row?.courseName|| String(row?.courseName)?.trim()?.length==0){
            throw new Error(`Please Enter valid course Name in row ${i+1}`);
          }
          if(!row?.sittings|| String(row?.sittings)?.trim()?.length==0){
            throw new Error(`Select Number of Sittings for row ${i+1}`);
          }
          if(!row?.certificateNumber|| String(row?.certificateNumber)?.trim()?.length==0){
            throw new Error(`Enter Certificate Number for  row ${i+1}`);
          }
          if(!row?.certificateAttachmentURL|| String(row?.certificateAttachmentURL)?.trim()?.length==0){
            throw new Error(`Upload Certificate Attachment for row ${i+1}`);
          }
          if(!row?.institutionName|| String(row?.institutionName)?.trim()?.length==0){
            throw new Error(`Enter School / Institute Name for row ${i+1}`);
          }
          if(!row?.startedOn|| String(row?.startedOn)?.trim()?.length==0){
            throw new Error(`Select Course Started Date for for row ${i+1}`);
          }
          if(!row?.finishedOn|| String(row?.finishedOn)?.trim()?.length==0){
            throw new Error(`Select Course End Date for for row ${i+1}`);
          }
          row?.table?.map((item)=>{
            if(!item?.Credit|| String(item?.Credit)?.trim()?.length==0){
              throw new Error(`Select the Subject and Minimum Credit row ${i+1}`);
            }
          })
         
        });
      } catch (err) {
        toast.error(err.message);
        return;
      }
    
      let url = "application/edit";
      let method = "PUT";
      let params = {
        job_application_id: Job_application_id,
        applicant_image: ProfileIMAGES,
        ip_address: "192.168.0.1",
        status: "pending",
        signature: signature.localImage,
        workflow: 1,
        computer_assessment: [
          { name: "Number of Questions", value: "" },
          { name: "Test Duration", value: "" },
        ],
        education_qualification: EducationQualification,
        applicant_temp_details: basicDetails,
        kin_details: KinDetails,
        physical_test: [],
        medical_test: [],
        computer_test: [],
        fitness_requirement: [],
        further_information: informations,
        referee_information: Referees,
        physical_test_state: "Lagos",
        computer_test_state: "Ikeja",
        medical_test_state: "Ikeja",
        medical_locations: medical_locations,
        physical_locations: physical_locations,
        computer_locations: computer_locations,
      };
      try {
        setShowLoader(true);
        const response = await PostMethod({ url, method, params });
        if (response.status) {
          setStepper(2);
          setShowLoader(false);
        } else {
          setShowLoader(false);
          toast.error("something went wrong please try again");
        }
      } catch (Error) {
        setShowLoader(false);
        console.log("Error", Error);
        toast.error("something went wrong please try again");
      }
    }
  };
  const CompleteOtherDetails = async () => {
    if (!otherDetails) {
      toast.error("Please Select State ");
      return;
    }
    if (physicalTest.length == 0) {
      toast.error("Try Again");
      return;
    }

    try {
      physicalTest.map((row) => {
        if (row.input == "input") {
          if (!row?.value || String(row.value).trim().length==0|| row.value =="") {
            throw new Error(`Please Enter ${row.name}`);
          }
          if (row?.value?.trim().length === 0 || row.value =="") {
            throw new Error(`Please Enter Valid ${row.name}`);
          }
        } else if (row.input == "check") {
          if (!row?.value||  row.value =="") {
            throw new Error(`Please Select ${row.name}`);
          }
          if (row?.value?.trim().length === 0|| row.value =="") {
            throw new Error(`Please Select Valid ${row.name}`);
          }
        }else{
          if (row?.value?.trim().length === 0 || row.value =="") {
            throw new Error(`Please Enter Valid ${row.name}`);
          }
        }
      });
    } catch (err) {
      toast.error(err.message);
      return;
    }

    if (!referenceDetails) {
      toast.error("Try Again");
      return;
    }

    if (referenceDetails?.fullName) {
      if (referenceDetails.fullName?.trim()?.length == 0) {
        toast.error("Please Enter Referee's Information Valid Full Name");
        return;
      }
    }
    if(Permanentaddeess?.Address){
      referenceDetails.Address =Permanentaddeess.Address
    }
    if (referenceDetails?.Phone) {
      if (referenceDetails.Phone?.trim()?.length == 0) {
        toast.error("Please Enter Referee's Information Valid Phone Number");
        return;
      }
    }

    if (referenceDetails.Address) {

      if (referenceDetails?.Address?.trim()?.length == 0) {
        toast.error("Please Enter Referee's Information Valid Address");
        return;
      }
    }
    if (referenceDetails?.Details) {
      if (referenceDetails.Details?.trim()?.length == 0) {
        toast.error("Please Enter Referee's Information Valid Details");
        return;
      }
    }

    if (furtherInformation.length == 0) {
      toast.error("Try Again");
      return;
    }

    try {
      furtherInformation.map((row) => {
        if (row.input == "check") {
          if (!row?.value) {
            throw new Error(`Please Select ${row.name}`);
          }

          if (row.value?.toLowerCase() == "yes") {
            if (!row?.name1Value) {
              throw new Error(`Please Give Details for ${row.name}`);
            }
            if (row?.name1Value?.trim()?.length == 0) {
              throw new Error(`Please Give Valid Details for ${row.name}`);
            }

            if (row?.name2) {
              if (!row?.name2Value) {
                throw new Error(
                  `Please Enter Reason for Leaving for ${row.name}`
                );
              }
              if (row?.name2Value?.trim()?.length == 0) {
                throw new Error(
                  `Please Enter Valid Reason for Leaving for ${row.name}`
                );
              }
            }
          }
        }
        if (row.input == "year") {
          if (!row?.year) {
            throw new Error(`Please Enter ${row.name} Year Value`);
          }
          if (row?.year?.length == 0) {
            throw new Error(`Please Enter ${row.name} Valid Year Value`);
          }
          if (!row?.month) {
            throw new Error(`Please Enter ${row.name} Month Value`);
          }
          if (row?.month?.length == 0) {
            throw new Error(`Please Enter ${row.name} Valid Month Value`);
          }
        }
      });
    } catch (err) {
      toast.error(err.message);
      return;
    }
    if (!Job_application_id) {
      toast.error("Something went wrong try again later");
      return;
    }
    if(referenceDetails?.Phone){
      if(String(referenceDetails?.Phone).length>0 && String(referenceDetails?.Phone).length !=10){
        toast.error("Enter Valid Referee’s Information Phone");
        return;
      }
    }
    try {
      let referenceDetailsset = [
        {
          name: "Full Name",
          value: referenceDetails.fullName,
          input: "text",
        },
        {
          name: "Phone",
          value: referenceDetails.Phone,
          input: "phone",
        },
        {
          name: "Address",
          value: referenceDetails.Address,
          input: "address",
        },
        {
          name: "Give details (if Yes)",
          value: referenceDetails.Details,
          input: "textarea",
        },
      ];
      setReferees(referenceDetailsset)
      let url = "application/edit";
      let method = "PUT";
      let params = {
        job_application_id: Job_application_id,
        applicant_image: ProfileIMAGES,
        ip_address: "192.168.0.1",
        status: "pending",
        signature: signature.localImage,
        workflow: 1,
        computer_assessment: [
          { name: "Number of Questions", value: "" },
          { name: "Test Duration", value: "" },
        ],
        education_qualification: EducationQualification,
        applicant_temp_details: basicDetails,
        kin_details: KinDetails,
        physical_test: physicalTest,
        medical_test: [],
        computer_test: [],
        fitness_requirement: physicalTest,
        further_information: furtherInformation,
        referee_information: referenceDetailsset,
        physical_test_state: otherDetails.selectedState,
        computer_test_state: otherDetails.selectedCbtState,
        medical_test_state: otherDetails.selectedMedicalState,
        physical_locations: [
          { value: otherDetails.location1 },
          { value: otherDetails.location2 },
          { value: otherDetails.location3 },
        ],
        medical_locations: [
          { value: otherDetails.medicalLocation1 },
          { value: otherDetails.medicalLocation2 },
          { value: otherDetails.medicalLocation3 },
        ],
        computer_locations: [
          { value: otherDetails.cbtLocation1 },
          { value: otherDetails.cbtLocation2 },
          { value: otherDetails.cbtLocation3 },
        ],
      };
      try {
        setphysical_locations([
          { value: otherDetails.location1 },
          { value: otherDetails.location2 },
          { value: otherDetails.location3 },
        ])
        setcomputer_locations([
          { value: otherDetails.cbtLocation1 },
          { value: otherDetails.cbtLocation2 },
          { value: otherDetails.cbtLocation3 },
        ])
        setmedical_locations([
          { value: otherDetails.medicalLocation1 },
          { value: otherDetails.medicalLocation2 },
          { value: otherDetails.medicalLocation3 },
        ])
        setShowLoader(true);
        const response = await PostMethod({ url, method, params });
        if (response.status) {
          setStepper(3);
          setShowLoader(false);
        } else {
          setShowLoader(false);
          toast.error("something went wrong please try again");
        }
      } catch (Error) {
        setShowLoader(false);
        console.log("Error", Error);
        toast.error("something went wrong please try again");
      }
    } catch (Error) {
      console.log("Error", Error);
    }
  };
  const CompletePreview = async () => {
    if(!Affirmationcheck){
      toast.error("Please Select the Affirmation");
      return;
    }
    if (!submittedDate) {
      toast.error("Please Select Submitted Date");
      return;
    }

    setConformModal(true);
  };

  const HandleComplete = async () => {
    try {
      let url = "application/edit";
      let method = "PUT";
      let params = {
        job_application_id: Job_application_id,
        applicant_image: ProfileIMAGES,
        ip_address: "192.168.0.1",
        signature: signature.localImage,
        status: "submitted",
        workflow: 1,
        computer_assessment: [
          { name: "Number of Questions", value: "" },
          { name: "Test Duration", value: "" },
        ],
        education_qualification: EducationQualification,
        applicant_temp_details: basicDetails,
        kin_details: KinDetails,
        physical_test: physicalTest,
        medical_test: [],
        computer_test: [],
        fitness_requirement: physicalTest,
        further_information: furtherInformation,
        referee_information: Referees,
        physical_test_state: otherDetails.selectedState,
        computer_test_state: otherDetails.selectedCbtState,
        medical_test_state: otherDetails.selectedMedicalState,
        physical_locations: [
          { value: otherDetails.location1 },
          { value: otherDetails.location2 },
          { value: otherDetails.location3 },
        ],
        medical_locations: [
          { value: otherDetails.medicalLocation1 },
          { value: otherDetails.medicalLocation2 },
          { value: otherDetails.medicalLocation3 },
        ],
        computer_locations: [
          { value: otherDetails.cbtLocation1 },
          { value: otherDetails.cbtLocation2 },
          { value: otherDetails.cbtLocation3 },
        ],
        submited_place: placeName.Address,
        submited_on: true,
      };

      setConformModal(false);
      setShowLoader(true);
      const response = await PostMethod({ url, method, params });
      if (response.status) {
        setStepper(0);
        setSubmittedDate("");
        setPlaceName("");
        setReferenceDetails({
          fullName: "",
          Phone: "",
          Details: "",
          Address: "",
        });
        setOtherDetails({
          selectedState: "",
          location1: null,
          location2: null,
          location3: null,
          cityList: [],
          cityMedicialList: [],
          cityCbtList: [],
          selectedCbtState: "",
          cbtLocation1: null,
          cbtLocation2: null,
          cbtLocation3: null,
          selectedMedicalState: "",
          medicalLocation1: null,
          medicalLocation2: null,
          medicalLocation3: null,
        });
        setFurtherInformation([]);
        setPhysicalTest([]);
        navigate("/")
        toast.success("Job Applied Successfully");
        setShowLoader(false);
      } else {
        setShowLoader(false);
        if (response.message) {
          toast.error(response.message);
        } else {
          toast.error("Something went wrong try again");
        }
      }
    } catch (Error) {
      setShowLoader(false);
      toast.error("Something went wrong try again");
      console.log("err in CompletePreview", Error);
    }
  };
  const OpenApplication = async (ids,CandidateDetails) => {

    const userid = localStorage.getItem("@userid");
    if (!userid) {
      toast.warn("User authentication Failed ");
      return;
    }
    try {
      if (!ids) {
        toast.error("Something went wrong try again later");
        return;
      }
      let url = "job/details";
      let method = "POST";
      let params = {
        job_uuid: ids,
      };
      let url1 = "test/jobDetails";
      let method1 = "POST";
      let params1 = {
        job_created_by: userid,
        job_id: ids,
      };
      setShowLoader(true);
      const response1 = await PostMethod({
        url: url1,
        method: method1,
        params: params1,
      });
      const response = await PostMethod({ url, method, params });
      if(response.result[0]){
        setJobDetails(response.result[0])
      }
      if (response1.status) {
        if (response1?.result) {
          if (response1.result.job_current_status == "submitted") {
            setShowLoader(false);
            CloseAgreementModal();
            toast.warn("Job Application Already Submitted");
            return;
          }
          if (response1.result?.applicant_temp_details) {
            if(response1.result?.applicant_temp_details[0]){
              setResidentialaddeess({Address:response1.result?.applicant_temp_details[18].value})
            }
            setJob_application_id(response1.result.job_application_id);
            if(response1.result.applicant_signature){
              const sigImages = await GetPublicURL(response1.result.applicant_signature)
              setSignature({ localImage: response1.result.applicant_signature,previewimage: sigImages});
            }            
            setbasicDetails(response1.result.applicant_temp_details);
            if(response1.result.kin_details){
              setBaseaddeess({Address:response1.result.kin_details[5].value})
            }
            setKinDetails(response1.result.kin_details);
            setWorkflow(response1.result.application_temp_workflow);
            setStepper(response1.result.workflow_status);
          }
          if (Gender == "male") {
            setPhysicalTest(response.result[0]?.test_requirement[0].values);
          } else {
            setPhysicalTest(response.result[0]?.test_requirement[1].values);
          }
          if (response1.result?.computer_locations) {
            setcomputer_locations(response1.result?.computer_locations);
            let datss = { ...otherDetails };
            if (response1.result?.computer_locations[0]) {
              datss.cbtLocation1 =
                response1.result?.computer_locations[0].value;
              datss.cbtLocation2 =
                response1.result?.computer_locations[1].value;
              datss.cbtLocation3 =
                response1.result?.computer_locations[2].value;
              if (response1.result?.medical_locations) {
                setmedical_locations(response1.result?.medical_locations);
                datss.medicalLocation1 =
                  response1.result?.medical_locations[0].value;
                datss.medicalLocation2 =
                  response1.result?.medical_locations[1].value;
                datss.medicalLocation3 =
                  response1.result?.medical_locations[2].value;
              }

              if (response1.result?.physical_locations) {
                setphysical_locations(response1.result?.physical_locations);
                datss.location1 = response1.result?.physical_locations[0].value;
                datss.location2 = response1.result?.physical_locations[1].value;
                datss.location3 = response1.result?.physical_locations[2].value;
                datss.selectedState = response1.result.physical_test_state;
                datss.selectedCbtState = response1.result.computer_test_state;
                datss.selectedMedicalState =
                  response1.result.medical_test_state;
              }
              setOtherDetails(datss);
            }
          }
          if (response1.result?.education_qualification) {
            setEducationQualification(response1.result.education_qualification);
          } else {
            setEducationQualification(
              response.result[0].education_qualification
            );
          }
      
          if (response1.result?.further_information) {
            setinformations(response1.result.further_information);
            setFurtherInformation(response1.result.further_information);
          } else {
            setinformations(response.result[0].informations);
            setFurtherInformation(response.result[0].informations);
          }
          if (response1.result?.referee_information) {
            setReferees(response1.result.referee_information);
          } else {
            setReferees(response.result[0].referees);
          }
          if (response1.result?.referee_information) {
            setReferees(response1.result.referee_information);
          } else {
            setReferees(response.result[0].referees);
          }
        }
        CloseAgreementModal();
        setJobApplied(false);
        setStepper(0);
        setShowLoader(false);
        setaffirmation(response.result[0].affirmation);
      } else {
        if (response.status) {
          if (response.result[0].applicant_temp_details) {
            const datas = response.result[0].applicant_temp_details;
            if (datas) {
              datas[1].value = CandidateDetails.candidate_first_name;
              datas[2].value = CandidateDetails.candidate_last_name;
              datas[4].value = CandidateDetails.candidate_state;
              datas[5].value = CandidateDetails.candidate_goverment_area;
              datas[6].value = CandidateDetails.candidate_gender;
              datas[8].value = CandidateDetails.candidate_marital_status;
              const timestamp = Number(CandidateDetails.candidate_dob); // Your input timestamp
              const date = new Date(timestamp);
              const formattedDate = formatDate(date);
              datas[7].value = formattedDate;
              datas[9].value = CandidateDetails.candidate_email;
              datas[11].value = CandidateDetails.candidate_main_phonenumber;
              datas[12].value = CandidateDetails.candidate_other_phonenumber;
              datas[13].value = CandidateDetails.candidate_religion;
              datas[14].value = CandidateDetails.candidate_language_spoken;
              datas[15].value = CandidateDetails.candidate_other_language_spoken;
              datas[16].value = CandidateDetails.candidate_hobbies;
              datas[17].value = CandidateDetails.candidate_permanent_address;
              datas[18].value = CandidateDetails.candidate_present_address;
              setbasicDetails(response.result[0].applicant_temp_details);
              if(response.result[0].kin_details){
                response.result[0].kin_details?.map((item)=>{
                  item.value=""
                })
                setKinDetails(response.result[0].kin_details);
              }

              setWorkflow(response.result[0].job_workflow);
              setEducationQualification(
                response.result[0].education_qualification
              );
              if (Gender == "male") {
                setPhysicalTest(response.result[0]?.test_requirement[0].values);
              } else {
                setPhysicalTest(response.result[0]?.test_requirement[1].values);
              }
              setFurtherInformation(response.result[0].informations)
              setinformations(response.result[0].informations);
              setReferees(response.result[0].referees);
              setaffirmation(response.result[0].affirmation);
            }
          }
          setShowLoader(false);
          CloseAgreementModal();
          setJobApplied(false);
          setStepper(0);
        } else {
          setShowLoader(false);
          if (response.message) {
            toast.error(response.message);
          } else {
            toast.error("Something went wrong");
          }
        }
      }
    } catch (Error) {
      setShowLoader(false);
      toast.error("Something went wrong");
      console.log("err in OpenApplication Error", Error);
    }
  };
  const CloseDetailModal = () => {
    setDetailModal(false);
  };
  const CloseAgreementModal = () => {
    setDetailModal(false);
  };
  const PreviewBack = () => {
    setStepper(2);
  };
  useEffect(()=>{
    if(id){
      GetcandidateDetails();
    }
  },[id])
  useEffect(() => {
    GetReligion();
    Getrelationship();
    GetEducations();
    GetEducationsLevel();
    const date = new Date();
    const formattedDate = date.toISOString().split("T")[0]; 
    setSubmittedDate(formattedDate)
  }, []);
  const GetAdddresslist = async (candidate_state) => {
    try {
      let url = "settings/baseaddresslist";
      let method = "POST";
      let params = {
        type: "physical",
      };
      const response = await PostMethod({ url, method, params });
      if (response.status) {

        let array = [];
        response?.result.map((item) => {
          if(candidate_state){
            if(String(item.base_address_state)?.toLowerCase()==String(candidate_state).toLowerCase()){
              array.push({ value: item.base_address, label: item.base_address });
            }
          }else{
            array.push({ value: item.base_address, label: item.base_address });
          }
        });
        setPhysicalList(array);
      }
      let url1 = "settings/baseaddresslist";
      let method1 = "POST";
      let params1 = {
        type: "cbt",
      };
      const response1 = await PostMethod({
        url: url1,
        method: method1,
        params: params1,
      });
      if (response1.status) {
        let arrays = [];
        response1?.result.map((item) => {
          if(candidate_state){
            if(String(item.base_address_state)?.toLowerCase()==String(candidate_state).toLowerCase()){
              arrays.push({ value: item.base_address, label: item.base_address });
            }
          }else{
            arrays.push({ value: item.base_address, label: item.base_address });
          }
        });
        setCBTList(arrays);
      }
    } catch (Error) {
      console.log("err in GetAdddresslist Error ", Error);
    }
  };
  const GetcandidateDetails = async () => {
    try {
      const userid = localStorage.getItem("@userid");
      if (!userid) {
        toast.warn("User authentication Failed ");
        return;
      }
      let url = "candidate/candidateDetails";
      let method = "POST";
      let params = {
        candidate_uuid: userid,
      };
      setShowLoader(true);
      const response = await PostMethod({ url, method, params });
      if (response.status) {
        if(response.result?.candidate_state){
          GetAdddresslist(response.result?.candidate_state)
        }
        setCandidateDetails(response.result);
        if(id){
          OpenApplication(id,response.result)
        }
        if (response?.result.candidate_gender) {
          setGender(response?.result.candidate_gender);
        }
        if(response.Signature){
          const Images = await GetPublicURL(response.Signature)
          setSignature({localImage :response.Signature, previewimage:Images});
        }
        if(response.result?.candidate_image){
          const responses = await GetPublicURL(response.result.candidate_image)
          setProfileIMAGES(response.result.candidate_image);
          setProfileIMAGES1(responses);
        }
      }else{
        setShowLoader(false);
      }
    } catch (Error) {
      setShowLoader(false);
      console.log("err in GetcandidateList Error", Error);
    }
  };
  const HandleBasicinfo = (value, index) => {
    const datas = [...basicDetails];
    datas[index].value = value;
    setbasicDetails(datas);
  };
  const HandleBasicinfoCheck = (value, index,) => {
    const datas = [...basicDetails];
    let array =[]
    if(datas[index].value){
      array = datas[index].value
      if(array?.indexOf(value)!=-1){
        array.splice(array.indexOf(value),1)
      }else{
        array.push(value)
      }
    }else{
      array.push(value)
    }
    datas[index].value = array;
    setbasicDetails(datas);
  };
  const HandleKindetails = (value, index) => {
    const datas = [...KinDetails];
    datas[index].value = value;
    setKinDetails(datas);
  };
  const GetReligion = async () => {
    try {
      let url = "settings/listeducation";
      let method = "POST";
      let params = {
        type: "religions",
      };
      const response = await PostMethod({ url, method, params });
      if (response.status) {
        let array = [];
        response.result?.map((item) => {
          array.push({
            value: item.education_name,
            label: item.education_name,
          });
        });
        setNigeriaReligions(array);
      }
    } catch (Error) {
      console.log("Error", Error);
    }
  };
  const Getrelationship = async () => {
    try {
      let url = "settings/listeducation";
      let method = "POST";
      let params = {
        type: "relationship",
      };
      const response = await PostMethod({ url, method, params });

      if (response.status) {
        let array = [];
        response.result?.map((item) => {
          array.push({
            value: item.education_name,
            label: item.education_name,
          });
        });
        setRelationshipData(array);
      }
    } catch (Error) {
      console.log("Error", Error);
    }
  };
  const GetEducations = async () => {
    try {
      let url = "settings/listeducation";
      let method = "POST";
      let params = {
        type: "qualification",
      };
      const response = await PostMethod({ url, method, params });
      if (response.status) {
        let array = [];
        response.result?.map((item) => {
          array.push({
            value: item.education_name,
            label: item.education_name,
          });
        });
        setEducationQualificationsInfo(array);
      }
    } catch (Error) {
      console.log("Error", Error);
    }
  };
  const GetEducationsLevel = async () => {
    try {
      let url = "settings/listeducation";
      let method = "POST";
      let params = {
        type: "level",
      };
      const response = await PostMethod({ url, method, params });
      if (response.status) {
        let array = [];
        response.result?.map((item) => {
          array.push({
            value: item.education_name,
            label: item.education_name,
          });
        });
        setEducationLevel(array);
      }
    } catch (Error) {
      console.log("Error", Error);
    }
  };
  const Handleaddress = (value) => {
    HandleKindetails(value.Address, 5);
    setBaseaddeess(value);
  };
  const HandleaddressPermanent = (value, index) => {
    HandleBasicinfo(value.Address, index);
  };
  // const HandleaddressResidential = (value, index) => {
  //   HandleBasicinfo(value.Address, index);
  //   setResidentialaddeess(value);
  // };
  const GoBacktopage =()=>{
    if(stepper!=0){
      setStepper(stepper-1)
    }
  }
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = ""; // For older browsers
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  useEffect(()=>{
    if(stepper==3){
      const formattedArray = [
        basicDetails.reduce((result, item) => {
          const sanitizedKey = item.name.replace(/\s+/g, ""); // Remove spaces from the key
          result[sanitizedKey] = item.value; // Assign the value to the sanitized key
          return result;
        }, {})
      ];
      setCandidateDetail(formattedArray[0])
    }
  },[stepper])
  let maxDate = formatDateToISO(new Date())

  // const HandleImageRemove = () => {
  //   setImagePreview("");
  // };
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleImageUpload = async(event) => {
    const file = event.target.files[0];
   
    try{
      setShowLoader(true);
      let today = Date.now();
      let Extention = String(file.name).split(".");
      let name = "signatures/attachment" + today + "." + Extention[Extention.length - 1];
      let contenttype = "application/pdf";
      if (Extention[Extention.length - 1] != "pdf") {
        contenttype = "image/png";
      }
      const data = await S3Upload({ name, file, contenttype });
      setShowLoader(false)
      // setProfileIMAGES1(data);
      setProfileIMAGES(data);
      if (file) {
        setProfileIMAGES1(URL.createObjectURL(file));
      }
      event.target.value = "";
    }catch(Error){
      setShowLoader(false);
    }
  };
  return (
    <Grid item>
      <LoaderModal ShowLoader={ShowLoader} setShowLoader={setShowLoader} />
      {jobApplied ? (""
      ) : (
        <Grid
          item
          container
          justifyContent={"space-between"}
          className="bg-white borderRadius10"
        >
          <Grid item lg={12} md={12} sm={12} xs={12} container className="p-3">
            <Box sx={{ width: "100%" }}>
              <Stepper
                activeStep={stepper}
                alternativeLabel
                connector={<CustomConnector activeStep={stepper} />}
              >
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel
                      sx={{
                        "& .MuiStepLabel-label.Mui-active": {
                          color: "#A7ABA9",
                          fontFamily: "PoppinsMedium",
                        },
                        "& .MuiStepLabel-iconContainer .Mui-active": {
                          color: "#A7ABA9",
                          fontFamily: "PoppinsMedium",
                        },
                        "& .MuiStepLabel-label.Mui-completed": {
                          color: "#222222",
                          fontFamily: "PoppinsMedium",
                        },
                        "& .MuiStepLabel-label": {
                          fontFamily: "PoppinsMedium",
                        },
                        "& .MuiStepLabel-iconContainer .Mui-completed": {
                          color: "#0FBE7C",
                          fontFamily: "PoppinsMedium",
                        },
                      }}
                    >
                      {label}
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>
            <Grid
              item
              lg={12}
              sm={12}
              md={12}
              xs={12}
              className="p-3 borderRadius10 mt-3"
              backgroundColor={"#3B82F60A"}
            >
              <h5
                className="Text-Prime-Black poppinsMedium text-center p-2"
                style={{ textDecoration: "underline" }}
              >
                {jobDetails.job_name}
              </h5>
            </Grid>
            <Grid
              item
              lg={12}
              sm={12}
              md={12}
              xs={12}
              className="p-3 borderRadius10 mt-3"
            >
              <h5 className="Text-Prime-Black poppinsMedium text-left pt-2">
                {stepper == 0
                  ? "Applicant Details"
                  : stepper == 1 ? "Educational Qualification"  : stepper == 2? "Other Details": "Preview"}
              </h5>
            </Grid>
            <Divider
              className="m-1 mb-3 w-100"
              sx={{ border: "1px solid #a7aba96e" }}
            />

            {stepper == 0 ? (
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid
                  item
                  container
                  lg={12}
                  xs={12}
                  justifyContent={"center"}
                  className="py-3"
                >
                  <Grid
                    item
                    container
                    lg={5.9}
                    xs={5.9}
                    className="p-3"
                    sx={{ backgroundColor: "#3B82F60A", borderRadius: "6px" }}
                    alignItems={"flex-start"}
                    alignContent={"flex-start"}
                  >
                    <h5 className="Text-Prime-Black poppinsMedium text-left pt-2">
                      Upload Photo {Mandatory()}
                    </h5>
                    <Divider
                      className="mt-2 w-100"
                      sx={{ border: "1px solid #a7aba96e" }}
                    />
                    <Grid
                      item
                      container
                      lg={12}
                      xs={12}
                      justifyContent={"center"}
                      className="mt-3"
                    >
                      {/* {ProfileIMAGES1 && (
                        <img
                          src={ProfileIMAGES1}
                          alt="profile"
                          height={"150px"}
                          width={"150px"}
                          className="img_fluid"
                        />
                      )} */}
                      <Grid item container lg={12} md={12} sm={12} xs={12} justifyContent={"space-between"} alignItems={"center"} >
                        <Grid item container lg={12} justifyContent={"center"}>
                          {ProfileIMAGES1 ? 
                            <Avatar sx={{ width: "100px", height: "100px" }} alt="profilepic" src={ProfileIMAGES1} />
                            : <Avatar alt="profilepic" sx={{ backgroundColor: "#D9D9D9", width: "100px", height: "100px" }}><BsFillPersonFill color={"#000000"} size={50} /></Avatar>}
                        </Grid>
                        <Grid item container lg={12} justifyContent={"center"} className="mt-3">
                          <input type="file" accept="image/*" style={{ display: "none" }} ref={fileInputRef} onChange={handleImageUpload} />
                          <GreenColorButton onClick={handleUploadClick} className="px-3 py-2" startIcon={<FiUpload color={"#ffffff"} size={24} />}>Change Photo</GreenColorButton>
                        </Grid>
                      </Grid>
                    </Grid>
                    {/* <Grid item container lg={12} xs={12} className="mt-3">
                      <p className="poppinsRegular Text-Prime-Gray text-left">
                        This photo has been taken from your profile details. To update it, please edit your profile details.{" "}
                      </p>
                    </Grid> */}
                  </Grid>

                </Grid>
                <Grid
                  item
                  container
                  lg={12}
                  xs={12}
                  className="p-3"
                  sx={{ backgroundColor: "#3B82F60A", borderRadius: "6px" }}
                >
                  <h5 className="Text-Prime-Black poppinsMedium text-left pt-2">
                    Basic Details
                  </h5>
                  <Divider
                    className="mt-2 w-100"
                    sx={{ border: "1px solid #a7aba96e" }}
                  />
                  <Grid
                    item
                    container
                    lg={12}
                    xs={12}
                    justifyContent={"space-between"}
                    className="mt-3"
                  >
                    {basicDetails?.map((item, index) => {
                      return (
                        <>
                          {item.input == "dropdown" ? (
                            <> 
                            
                              <Grid
                                item
                                container
                                lg={3.8}
                                md={3.8}
                                sm={12}
                                xs={12}
                                
                                className="mt-2"
                                flexDirection={"column"}
                              >
                                <p className="text-black poppinsMedium pb-2 text-left">
                                  {item.name} {Mandatory()}
                                </p>
                                {
                                  item.name =="State of Origin"||item.name =="Local Government Area"||
                                  item.name =="Gender"?
                                    <CustomInput
                                      backgroundColor="#EEECEC"
                                      width={"100%"}
                                      height={"45px"}
                                      placeholderColor={"#666666"}
                                      padding={"2.5% 3% 2.5% 0%"}
                                      border={"1px solid  #666666"}
                                      fontFamily={"PoppinsMedium"}
                                      placeholder={"Enter your " + item.name}
                                      maxLength={100}
                                      value={item.value}
                                      disabled={true}
                                      onChange={(e) =>
                                        HandleBasicinfo(e.target.value, index)
                                      }
                                    />
                                    :
                                    <CustomDropDown
                                      placeholder={"Select your " + item.name}
                                      data={
                                        item.name == "Title"
                                          ? TitleInfo
                                          : item.name == "Gender" ? GenderInfo : item.name == "Marital Status" ? MaritalStatusInfo    : item.name == "Religion" ? NigeriaReligions : NigeriaStatesInfo
                                      }
                                      borderRadius={"8px"}
                                      backgroundColor="#FFFFFF"
                                      isDisabled={item.name=="State of Origin"? true:false}
                                      selected={
                                        item?.value && {
                                          label: item.value,
                                          value: item.value,
                                        }
                                      }
                                      onChange={(e) =>
                                        HandleBasicinfo(e.value, index)
                                      }
                                    />}                              
                              </Grid>
                            </>
                          ) :item.name == "Permanent Home Address" ? (
                            <Grid
                              item
                              container
                              lg={3.8}
                              md={3.8}
                              sm={12}
                              xs={12}
                              className="mt-2"
                              flexDirection={"column"}
                            >
                              <p className="text-black poppinsMedium pb-2 text-left">
                                {item.name} {Mandatory()}
                              </p>
                              <Grid>
                                <CustomInput
                                  backgroundColor="#EEECEC"
                                  width={"100%"}
                                  height={"45px"}
                                  placeholderColor={"#666666"}
                                  padding={"2.5% 3% 2.5% 0%"}
                                  border={"1px solid  #666666"}
                                  fontFamily={"PoppinsMedium"}
                                  placeholder={"Enter your " + item.name}
                                  maxLength={100}
                                  value={item.value}
                                  disabled={true}
                                  onChange={(e) =>
                                    HandleaddressPermanent(e.target.value, index)
                                  }
                                />
                              </Grid>
                             
                            </Grid>
                          ) :item.name == "Present Residential Address" ? (
                            <Grid
                              item
                              container
                              lg={3.8}
                              md={3.8}
                              sm={12}
                              xs={12}
                              className="mt-2"
                              flexDirection={"column"}
                            >
                              <p className="text-black poppinsMedium pb-2 text-left">
                                {item.name}
                              </p>
                              <Grid>
                                {/* <AutoComplete
                                  placeholder={"Enter Residential Address"}
                                  Location={Residentialaddeess?.Address}
                                  setLocation={(e) =>  HandleBasicinfo(value.Address, index)}
                                  // setLocation={(e) => HandleaddressResidential(e, index)}
                                  height={"30px"}
                                /> */}

                                <CustomInput
                                  backgroundColor="#FFFFFF"
                                  width={"100%"}
                                  height={"45px"}
                                  placeholderColor={"#666666"}
                                  padding={"2.5% 3% 2.5% 0%"}
                                  border={"1px solid  #666666"}
                                  fontFamily={"PoppinsMedium"}
                                  placeholder={"Enter Residential Address"}
                                  maxLength={100}
                                  value={Residentialaddeess?.Address}

                                  onChange={(e) => HandleBasicinfo(e.target.value, index) }
                                />
                               
                              </Grid>
                             
                            </Grid>
                          ): item.input == "text" ? (
                            <Grid
                              item
                              container
                              lg={3.8}
                              md={3.8}
                              sm={12}
                              xs={12}
                              className="mt-2"
                              flexDirection={"column"}
                            >
                              <p className="text-black poppinsMedium pb-2 text-left">
                                {item.name =="Surname"?"First Name" :item.name} { item.name !="Other Languages Spoken" &&  item.name !="Other Name" && item.name !="Repeat Email"&& item.name !="Hobbies" && Mandatory()}
                              </p>
                             
                              <CustomInput
                                backgroundColor={ item.name == "Surname" ||
                                  item.name == "Last Name" || item.name == "Email" ? "#EEECEC":"#FFFFFF"}
                                width={"100%"}
                                height={"45px"}
                                placeholderColor={"#666666"}
                                padding={"2.5% 3% 2.5% 0%"}
                                border={"1px solid  #666666"}
                                fontFamily={"PoppinsMedium"}
                                placeholder={"Enter your " + item.name}
                                maxLength={100}
                                value={item.value}
                                disabled={
                                  item.name == "Surname" ||
                                  item.name == "Last Name" ||item.name == "Email"
                                    ? true : false
                                }
                                onChange={(e) =>
                                  HandleBasicinfo(e.target.value, index)
                                }
                              />
                            </Grid>
                          ) : item.input == "date" ? (
                            <Grid
                              item
                              container
                              lg={3.8}
                              md={3.8}
                              sm={12}
                              xs={12}
                              className="mt-2"
                              flexDirection={"column"}
                            >
                              <p className="text-black poppinsMedium pb-2 text-left">
                                {item.name} {Mandatory()}
                              </p>
                              {item.name =="Date of Birth"?
                                <CustomInput
                                  backgroundColor="#EEECEC"
                                  width={"100%"}
                                  height={"45px"}
                                  placeholderColor={"#666666"}
                                  padding={"2.5% 3% 2.5% 0%"}
                                  border={"1px solid  #666666"}
                                  fontFamily={"PoppinsMedium"}
                                  placeholder={"Enter your " + item.name}
                                  maxLength={100}
                                  value={item.value}
                                  disabled={true}
                                />
                                :
                                <CustomInput
                                  backgroundColor="#FFFFFF"
                                  width={"100%"}
                                  height={"45px"}
                                  placeholderColor={"#666666"}
                                  padding={"2.5% 3% 2.5% 0%"}
                                  border={"1px solid  #666666"}
                                  fontFamily={"PoppinsMedium"}
                                  placeholder={"Enter your " + item.name}
                                  maxLength={100}
                                  maxDate={maxDate}
                                  type={"date"}
                                  value={item.value}
                                  onChange={(e) =>
                                    HandleBasicinfo(e.target.value, index)
                                  }
                                />
                              }
                            </Grid>
                          ) : item.input == "check" ? (
                            <Grid
                              item
                              container
                              lg={3.8}
                              md={3.8}
                              sm={12}
                              xs={12}
                              className="mt-2"
                            >
                              <p className="Text-Prime-Black poppinsMedium pb-2 text-left">
                                Languages Spoken {Mandatory()}
                              </p>
                              <Grid item container lg={12} flexWrap={"wrap"}>
                                <Grid
                                  item
                                  container
                                  lg={4}
                                  alignItems={"center"}
                                >
                                  <CustomCheckBox
                                    disableColor={"transparent"}
                                    checked={
                                      item.value?.indexOf("English") !=-1  ? true : false
                                    }
                                    onChange={() =>
                                      HandleBasicinfoCheck("English", index)
                                    }
                                  />
                                  <p className="poppinsRegular Text-Prime-Gray text-left">
                                    English
                                  </p>
                                </Grid>
                                <Grid
                                  item
                                  container
                                  lg={4}
                                  alignItems={"center"}
                                >
                                  <CustomCheckBox
                                    disableColor={"transparent"}
                                    checked={
                                      item.value?.indexOf("Hausa") !=-1 ? true : false
                                    }
                                    onChange={() =>
                                      HandleBasicinfoCheck("Hausa", index)
                                    }
                                  />
                                  <p className="poppinsRegular Text-Prime-Gray text-left">
                                    Hausa
                                  </p>
                                </Grid>
                                <Grid
                                  item
                                  container
                                  lg={4}
                                  alignItems={"center"}
                                >
                                  <CustomCheckBox
                                    disableColor={"transparent"}
                                    checked={
                                      item.value?.indexOf("Igbo") !=-1  ? true : false
                                    }
                                    onChange={() =>
                                      HandleBasicinfoCheck("Igbo", index)
                                    }
                                  />
                                  <p className="poppinsRegular Text-Prime-Gray text-left">
                                    Igbo
                                  </p>
                                </Grid>
                                <Grid
                                  item
                                  container
                                  lg={4}
                                  alignItems={"center"}
                                >
                                  <CustomCheckBox
                                    disableColor={"transparent"}
                                    checked={
                                      item.value?.indexOf("Yoruba") !=-1  ? true : false
                                    }
                                    onChange={() =>
                                      HandleBasicinfoCheck("Yoruba", index)
                                    }
                                  
                                  />
                                  <p className="poppinsRegular Text-Prime-Gray text-left">
                                    Yoruba
                                  </p>
                                </Grid>
                                <Grid
                                  item
                                  container
                                  lg={4}
                                  alignItems={"center"}
                                >
                                  <CustomCheckBox
                                    disableColor={"transparent"}
                                    checked={
                                      item.value?.indexOf("Others") !=-1  ? true : false
                                    }
                                    onChange={() =>
                                      HandleBasicinfoCheck("Others", index)
                                    }

                                  />
                                  <p className="poppinsRegular Text-Prime-Gray text-left">
                                    Others
                                  </p>
                                </Grid>
                              </Grid>
                            </Grid>
                          ) : (
                            item.input == "phone" && (
                              <Grid
                                item
                                container
                                lg={3.8}
                                md={3.8}
                                sm={12}
                                xs={12}
                                flexDirection={"column"}
                                className="mt-2"
                              >
                                <p className="Text-Prime-Black poppinsMedium pb-2 text-left">
                                  {item.name} { item.name=="Main Phone Number" && Mandatory()}
                                </p>
                                <CustomInput
                                  placeholder="E.g. XXX XXX XXXX"
                                  backgroundColor="#FFFFFF"
                                  width={"100%"}
                                  height={"45px"}
                                  placeholderColor={"#666666"}
                                  padding={"2.5% 3% 2.5% 2%"}
                                  border={"1px solid  #666666"}
                                  fontFamily={"PoppinsMedium"}
                                  maxLength={10}
                                  type="number"
                                  value={item.value}
                                  disabled={
                                    item.name == "Main Phone Number"
                                      ? true
                                      : false
                                  }
                                  InputFrontProps={
                                    <p className="Text-Prime-Black  poppinsMedium pr-1" style={{wordBreak:"unset"}} >
                                      +234
                                    </p>
                                  }
                                  InputProps={
                                    <BiSolidPhone color={"#666666"} size={24} />
                                  }
                                  onChange={(e) =>
                                    HandleBasicinfo(e.target.value, index)
                                  }
                                />
                              </Grid>
                            )
                          )}
                        </>
                      );
                    })}
                  </Grid>
                </Grid>
                <Grid
                  container
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  className="p-3 borderRadius10 mt-3"
                  backgroundColor={"#3B82F60A"}
                >
                  <Grid
                    item
                    container
                    lg={12}
                    md={12}
                    sm={12}
                    alignItems={"center"}
                  >
                    <h4 className="Text-Prime-Black poppinsMedium text-left pl-2">
                      Next of Kin Details
                    </h4>
                  </Grid>
                  <Divider
                    className="mt-3 w-100"
                    sx={{ border: "1px solid #a7aba96e" }}
                  />
                  <Grid item container lg={12} xs={12} className="mt-3">
                    {KinDetails?.map((item, index) => {
                      return (
                        <>
                          {item.input == "text" ? (
                            <Grid
                              item
                              container
                              lg={3.8}
                              md={3.8}
                              sm={12}
                              xs={12}
                              className="m-2"
                              flexDirection={"column"}
                            >
                              <p className="text-black poppinsMedium pb-2 text-left">
                                {item.name} {Mandatory()}
                              </p>
                              <CustomInput
                                backgroundColor="#FFFFFF"
                                width={"100%"}
                                height={"45px"}
                                placeholderColor={"#666666"}
                                padding={"2.5% 3% 2.5% 0%"}
                                border={"1px solid  #666666"}
                                fontFamily={"PoppinsMedium"}
                                placeholder={"Enter " + item.name}
                                maxLength={100}
                                value={item.value}
                                onChange={(e) =>
                                  HandleKindetails(e.target.value, index)
                                }
                              />
                            </Grid>
                          ) : item.input == "dropdown" ? (
                            <Grid
                              item
                              container
                              lg={3.8}
                              md={3.8}
                              sm={12}
                              xs={12}
                              className="m-2"
                              flexDirection={"column"}
                            >
                              <p className="text-black poppinsMedium pb-2 text-left">
                                Relationship {Mandatory()}
                              </p>
                              <CustomDropDown
                                placeholder={"Select Relationship"}
                                data={RelationshipData}
                                borderRadius={"8px"}
                                backgroundColor="#FFFFFF"
                                selected={
                                  item?.value && {
                                    label: item.value,
                                    value: item.value,
                                  }
                                }
                                onChange={(e) =>
                                  HandleKindetails(e.value, index)
                                }
                              />
                            </Grid>
                          ) : item.input == "phone" ? (
                            <Grid
                              item
                              container
                              lg={3.8}
                              md={3.8}
                              sm={12}
                              xs={12}
                              className="m-2"
                              flexDirection={"column"}
                            >
                              <p className="Text-Prime-Black poppinsMedium pb-2 text-left">
                                Main Phone Number {Mandatory()}
                              </p>
                              <CustomInput
                                placeholder="E.g. XXX XXX XXXX"
                                backgroundColor="#FFFFFF"
                                width={"100%"}
                                height={"45px"}
                                placeholderColor={"#666666"}
                                padding={"2.5% 3% 2.5% 2%"}
                                border={"1px solid  #666666"}
                                fontFamily={"PoppinsMedium"}
                                maxLength={10}
                                type="number"
                                value={item.value}
                                InputFrontProps={
                                  <p className="Text-Prime-Black poppinsMedium pr-2" style={{wordBreak:"unset"}}>
                                    +234
                                  </p>
                                }
                                InputProps={
                                  <BiSolidPhone color={"#666666"} size={24} />
                                }
                                onChange={(e) =>
                                  HandleKindetails(e.target.value, index)
                                }
                              />
                            </Grid>
                          ) : (
                            item.input == "address" && (
                              <Grid
                                item
                                container
                                className="mt-2"
                                lg={3.8}
                                md={3.8}
                                sm={12}
                                xs={12}
                              >
                                <p className="Text-Prime-Black poppinsMedium pb text-left">
                                  {item.name} {Mandatory()}
                                </p>
                                {/* <AutoComplete
                                  placeholder={"Enter Address"}
                                  Location={Baseaddeess?.Address}
                                  setLocation={(e) => Handleaddress(e, index)}
                                  height={"30px"}
                                /> */}

                                <CustomInput
                                  backgroundColor="#FFFFFF"
                                  width={"100%"}
                                  height={"45px"}
                                  placeholderColor={"#666666"}
                                  padding={"2.5% 3% 2.5% 0%"}
                                  border={"1px solid  #666666"}
                                  fontFamily={"PoppinsMedium"}
                                  placeholder={"Enter Address"}
                                  maxLength={100}
                                  value={Baseaddeess?.Address}
                                  onChange={(e) =>
                                    // HandleKindetails(e.target.value, index)
                                    Handleaddress(e.target.value, index)
                                  }
                                />
                              </Grid>
                            )
                          )}
                        </>
                      );
                    })}
                  </Grid>
                </Grid>
                <Grid
                  container
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  className="p-3 mt-3"
                >
                  <Grid
                    item
                    container
                    lg={12}
                    md={12}
                    sm={12}
                    justifyContent={"flex-end"}
                    alignItems={"flex-end"}
                  >
                    <PrimeGrayBorderColorButton
                      type="submit"
                      className="px-3 py-2"
                      onClick={() => navigate("/")}
                    >
                      Back
                    </PrimeGrayBorderColorButton>
                    <GreenColorButton
                      type="submit"
                      className="px-3 py-2 mx-2"
                      onClick={() => ApplicationComplete()}
                    >
                      Save & Next
                    </GreenColorButton>
                  </Grid>
                </Grid>
              </Grid>
            ) : stepper == 1 ? (
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <EducationalQualification
                  kindetails={KinDetails}
                  setShowLoader={setShowLoader}
                  setkindetails={setKinDetails}
                  informations={informations}
                  referees={Referees}
                  affirmationss={affirmation}
                  affirmation={setaffirmation}
                  setEducationsDetails={setEducationQualification}
                  EducationsDetails={EducationQualification}
                  EducationQualificationsInfo={EducationQualificationsInfo}
                  EducationLevel={EducationLevel}
                />
                <Grid
                  container
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  className="p-3 mt-3"
                >
                  <Grid
                    item
                    container
                    lg={12}
                    md={12}
                    sm={12}
                    justifyContent={"flex-end"}
                    alignItems={"flex-end"}
                  >
                    <PrimeGrayBorderColorButton
                      type="submit"
                      className="px-3 py-2"
                      onClick={()=>GoBacktopage()}
                    >
                      Previous
                    </PrimeGrayBorderColorButton>
                    <GreenColorButton
                      type="submit"
                      className="px-3 py-2 mx-2"
                      onClick={() => EducationComplete()}
                    >
                      Save & Next
                    </GreenColorButton>
                  </Grid>
                </Grid>
              </Grid>
            ) : stepper == 2 ? (
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <CandidateOtherDetails
                  referenceDetails={referenceDetails}
                  setReferenceDetails={setReferenceDetails}
                  furtherInformation={furtherInformation}
                  physicalTest={physicalTest}
                  setPhysicalTest={setPhysicalTest}
                  setFurtherInformation={setFurtherInformation}
                  otherDetails={otherDetails}
                  setOtherDetails={setOtherDetails}
                  PhysicalList={PhysicalList}
                  CBTList={CBTList}
                  Referees={Referees}
                  informations={informations}
                  Permanentaddeess={Permanentaddeess}
                  setPermanentaddeess={setPermanentaddeess}
                />
                <Grid
                  container
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  className="p-3 mt-3"
                >
                  <Grid
                    item
                    container
                    lg={12}
                    md={12}
                    sm={12}
                    justifyContent={"flex-end"}
                    alignItems={"flex-end"}
                  >
                    <PrimeGrayBorderColorButton
                      type="submit"
                      onClick={()=>GoBacktopage()}
                      className="px-3 py-2"
                    >
                      Previous
                    </PrimeGrayBorderColorButton>
                    <GreenColorButton
                      type="submit"
                      className="px-3 py-2 mx-2"
                      onClick={() => CompleteOtherDetails()}
                    >
                      Save & Next
                    </GreenColorButton>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              stepper == 3 && (
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid item lg={12} xs={12} className="px-3">
                    <Grid
                      item
                      lg={12}
                      sm={12}
                      md={12}
                      xs={12}
                      container
                      className="px-2 py-2"
                      alignItems={"center"}
                    >
                      <img
                        src={PSCLogo}
                        alt="PSCLogo"
                        height={60}
                        width={60}
                        className="img_fluid"
                      />
                      <h3 className="mx-2 poppinsSemiBold Text-Prime-Black text-center">
                        {/* Police Service Commission */}
                        {jobDetails?.job_name ? jobDetails.job_name : "---"}
                      </h3>
                    </Grid>
                    <Divider
                      className="w-100"
                      sx={{ border: "1px solid #a7aba96e" }}
                    />
                    <Grid
                      item
                      lg={12}
                      sm={12}
                      md={12}
                      xs={12}
                      container
                      className="p-2"
                      alignItems={"center"}
                      justifyContent={"space-between"}
                    >
                      <Grid
                        item
                        lg={10}
                        sm={10}
                        md={10}
                        xs={10}
                        container
                        className="p-2"
                        alignItems={"center"}
                      >
                        <Grid
                          item
                          lg={12}
                          sm={12}
                          md={12}
                          xs={12}
                          container
                          className="py-2"
                          justifyContent={"space-between"}
                        >
                          <Grid item lg={6} sm={6} md={6} xs={6}>
                            <p className="poppinsMedium Text-Prime-Black text-left">
                              Name of the Post Applying for
                            </p>
                          </Grid>
                          <Grid item lg={6} sm={6} md={6} xs={6}>
                            <p className="poppinsRegular Text-Prime-Black text-left">
                              {jobDetails?.job_name
                                ? jobDetails?.job_name
                                : "--"}
                            </p>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          lg={12}
                          sm={12}
                          md={12}
                          xs={12}
                          container
                          style={{ borderBottom: "2px dotted black" }}
                        />
                        <Grid
                          item
                          lg={12}
                          sm={12}
                          md={12}
                          xs={12}
                          container
                          className="py-2"
                          justifyContent={"space-between"}
                        >
                          <Grid item lg={6} sm={6} md={6} xs={6}>
                            <p className="poppinsMedium Text-Prime-Black text-left">
                              Notification Number
                            </p>
                          </Grid>
                          <Grid item lg={6} sm={6} md={6} xs={6}> 
                            <p className="poppinsRegular Text-Prime-Black text-left">
                              {jobDetails?.job_post_number
                                ? jobDetails?.job_post_number
                                : "--"}
                            </p>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          lg={12}
                          sm={12}
                          md={12}
                          xs={12}
                          container
                          style={{ borderBottom: "2px dotted black" }}
                        />
                      </Grid>
                      <Grid
                        item
                        lg={2}
                        sm={2}
                        md={2}
                        xs={2}
                        container
                        justifyContent={"flex-end"}
                      >
                        <img
                          src={ProfileIMAGES1}
                          alt="PSCLogo"
                          height={"150px"}
                          width={"150px"}
                          className="img_fluid"
                        />
                      </Grid>
                    </Grid>
                    <ApplicationDetails
                      refereeinformation={Referees}
                      affirmation={affirmation}
                      furtherinformation={furtherInformation}
                      Data={basicDetails}
                      EducationQualification={EducationQualification}
                      kindetails={KinDetails}
                      PhysicalList={physicalTest}
                      isShowAll={true}
                      CandidateDetail={CandidateDetail}
                      otherDetails={otherDetails}
                      physicalTestLocations={physical_locations}
                      MedicalTestLocations={medical_locations}
                      ComputerTestLocations={computer_locations}
                      EducationQualifications={EducationQualification}
                      Affirmationcheck={Affirmationcheck}
                      setAffirmationcheck={setAffirmationcheck}
                    />
                    <Grid
                      item
                      container
                      lg={12}
                      xs={12}
                      justifyContent={"space-between"}
                      className="mt-3"
                    >
                      <Grid
                        item
                        container
                        lg={3.8}
                        md={3.8}
                        sm={12}
                        xs={12}
                        flexDirection={"column"}
                      >
                        <p className="Text-Prime-Black poppinsMedium pb-2 text-left">
                          Submitted on Date
                        </p>
                        <DatePicker
                          isFuture={true}
                          placeholder={"DD/MM/YYYY"}
                          height={"45px"}
                          disabled={true}
                          fontFamily={"PoppinsMedium"}
                          backgroundColor="#FFFFFF"
                          border={"1px solid  #666666"}
                          Value={submittedDate}
                          handleInput={(e) => console.log(e)}
                        />
                      </Grid>
                      <Grid item container lg={4} md={4} sm={12} xs={12} />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    item
                    lg={12}
                    sm={12}
                    md={12}
                    xs={12}
                    className="p-3 mt-3"
                  >
                    <Grid
                      item
                      container
                      lg={12}
                      md={12}
                      sm={12}
                      justifyContent={"flex-end"}
                      alignItems={"flex-end"}
                    >
                      <PrimeGrayBorderColorButton
                        type="submit"
                        className="px-3 py-2"
                        onClick={() => PreviewBack()}
                      >
                        Previous
                      </PrimeGrayBorderColorButton>
                      <GreenColorButton
                        type="submit"
                        className="px-3 py-2 mx-2"
                        onClick={() => CompletePreview()}
                      >
                        Save & Next
                      </GreenColorButton>
                    </Grid>
                  </Grid>
                </Grid>
              )
            )}
          </Grid>
        </Grid>
      )}

      <CustomModal
        open={conformModal}
        setOpen={setConformModal}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "25%" : "95%"}
        modalContent={
          <Grid
            item
            container
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <CiCircleQuestion color={"#12A59B"} size={100} />
            <p className="poppinsRegular Text-Prime-Black pt-3 text-center">
              Are you sure you want to submit?
            </p>
            <p className="poppinsLight Text-Prime-Gray pt-3 text-center">
              Ensure all details are correct before final submission.
            </p>
          </Grid>
        }
        modalFooter={
          <Grid item container display={"flex"} justifyContent={"center"}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-5 py-2"
              onClick={() => setConformModal(false)}
            >
              No
            </PrimeGrayBorderColorButton>
            <DarkGreenColorButton
              type="submit"
              className="px-5 py-2 ml-2"
              onClick={() => HandleComplete()}
            >
              Yes
            </DarkGreenColorButton>
          </Grid>
        }
      />
      <CustomModal
        open={detailModal}
        setOpen={CloseDetailModal}
        divider={false}
        header={true}
        contentScroll={true}
        modalTitle={
          <h5 className="poppinsSemiBold Text-Prime-Black text-left">
            View Post Details
          </h5>
        }
        width={window.innerWidth > 600 ? "55%" : "95%"}
        modalContent={
          <Grid
            item
            container
            flexDirection={"column"}
            justifyContent={"flex-start"}
            alignItems={"flex-start"}
            textAlign={"left"}
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              container
              justifyContent={"space-between"}
            >
              <Grid
                item
                container
                lg={2.8}
                md={5.8}
                sm={12}
                xs={12}
                flexDirection={"column"}
              >
                <p className="text-black poppinsMedium pb-2 text-left">
                  Post Name
                </p>
                <p className="poppinsNormal Text-Prime-Black text-left">
                  {jobDetails?.job_name ? jobDetails?.job_name : "--"}
                </p>
              </Grid>
              <Grid
                item
                container
                lg={2.8}
                md={5.8}
                sm={12}
                xs={12}
                flexDirection={"column"}
              >
                <p className="text-black poppinsMedium pb-2 text-left">
                  Start Date
                </p>
                <p className="poppinsNormal Text-Prime-Black  text-left">
                  {jobDetails?.job_start_date
                    ? OnlyDateConverter(jobDetails?.job_start_date)
                    : "--"}
                </p>
              </Grid>
              <Grid
                item
                container
                lg={2.8}
                md={5.8}
                sm={12}
                xs={12}
                flexDirection={"column"}
              >
                <p className="text-black poppinsMedium pb-2 text-left">
                 Close Date
                </p>
                <p className="poppinsNormal Text-Prime-Black text-left">
                  {jobDetails?.job_end_date
                    ? OnlyDateConverter(jobDetails?.job_end_date)
                    : "--"}
                </p>
              </Grid>
              <Grid
                item
                container
                lg={2.8}
                md={5.8}
                sm={12}
                xs={12}
                flexDirection={"column"}
              >
                <p className="text-black poppinsMedium pb-2 text-left">
                  Number of Opening
                </p>
                <p className="poppinsNormal Text-Prime-Black text-left">
                  {jobDetails?.openings_count
                    ? FormatAmount(jobDetails?.openings_count)
                    : "--"}
                </p>
              </Grid>
            </Grid>
            <Divider
              className="w-100 mt-2"
              sx={{ border: "1px solid #a7aba96e" }}
            />

            <p className="poppinsNormal Text-Prime-Black pt-2 text-left">
              Here are the basic requirements for the role of Cadet Assistant
              Superintendent of Police (ASP):
            </p>
            <h5 className="poppinsSemiBold Text-Prime-Black pt-3 text-left">
              Qualification:
            </h5>
            {jobDetails?.job_qualifications?.filter(item => item.value).map((items, index) => {
              return (
                <> {items.value && 
                  <p  key={index} className="poppinsNormal Text-Prime-Black pt-3 text-left"> {index + 1}. {items.name} </p>}
                </>
              );
            })}
          </Grid>
        }
        modalFooter={
          <Grid item container display={"flex"} justifyContent={"flex-end"}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-5"
              onClick={() => CloseDetailModal()}
            >
              Close
            </PrimeGrayBorderColorButton>
          </Grid>
        }
      />
    </Grid>
  );
};

export default ApplyJob;
